module.exports = __webpack_public_path__ + "static/media/om_beard_long_diamond__v_vector.f4ef7b54.svg";